/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-lone-blocks */
import React, { useState, Fragment, useEffect } from "react";
import {
  SearchCircleIcon as SolidSearch,
  UserIcon,
  UserGroupIcon,
  ChatAlt2Icon,
  CloudIcon,
  CogIcon,
  CodeIcon,
  InboxIcon,
} from "@heroicons/react/solid";
import {
  UserIcon as OutlineUserIcon,
  UserGroupIcon as OutlineUserGroupIcon,
  ChatAlt2Icon as OutlineChatAlt2Icon,
  CloudIcon as OutlineCloudIcon,
  CogIcon as OutlineCogIcon,
  ChatAltIcon,
  InboxIcon as OutlineInboxIcon,
} from "@heroicons/react/outline";
import { Menu, Transition } from "@headlessui/react";
import { useNavigate, useParams } from "react-router-dom";
import backendService from "../services.js/backendService";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import { SocketContext } from "../services.js/socket";
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from "react-query";
import Circles from "react-loading-icons/dist/components/circles";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const FriendRequests = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_URL}/getfriendrequests`, {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": backendService.getToken(),
      },
    });
    return res.data.friendRequests;
  } catch (error) {
    return error.response;
  }
};

function VerticalMenu({
  expand,
  openSearchUser,
  friends,
  groups,
  openFriends,
  notification,
  codeSpace,
  setIsMobileMenuOpen,
}) {
  const { screen } = useParams();

  const socket = React.useContext(SocketContext);
  const [searchUsersOption, setSearchUsersOption] = useState(false);
  const [issettingopen, setissettingopen] = useState(false);
  const [friendsOption, setFriendsOption] = useState(
    screen && screen === "friends" ? true : false
  );
  const [conversationsOption, setConversationsOption] = useState(
    screen && screen === "inbox" ? true : false
  );
  const [groupChatsOption, setGroupChatsOption] = useState(
    screen && screen === "groups" ? true : false
  );
  const [codeSpaceOption, setCodeSpaceOption] = useState(
    screen && screen === "codespace" ? true : false
  );
  const [friendsRequestNotification, setFriendsRequestNotification] =
    useState(0);
  const [notifications, setNotifications] = useState(null);
  const {
    data: requestData,
    status: statusRequest,
    refetch: refetchRequest,
  } = useQuery("friendRequest", FriendRequests, {
    retry: true,
  });
  const navigate = useNavigate();
  useEffect(() => {
    if (statusRequest === "success") {
      setFriendsRequestNotification(requestData?.length);
    }
  }, [statusRequest, requestData]);
  const getNotification = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL}/getnotification`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": backendService.getToken(),
        },
      });
      setNotifications(res.data.Status);
    } catch (error) {
      console.log(error.response);
    }
  };
  const changeNotification = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/changenotif`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": backendService.getToken(),
        },
      });
     
    } catch (error) {
      console.log(error.response);
    }
  };
  useEffect(async () => {
    await getNotification();
    notification(notifications);
  }, [notifications]);

  useEffect(() => {
    if (openFriends) {
      {
        setFriendsOption(true);
        friends(true);
        setSearchUsersOption(false);
        setConversationsOption(false);
        setGroupChatsOption(false);
        openSearchUser(false);
        groups(false);
      }
    }
  }, [openFriends]);
  const queryClient = useQueryClient();
  return (
    <div className="flex-col h-full  bg-palette_color1">
      <ReactTooltip delayShow={500} delayHide={100} />
      <div className="h-[90%] flex items-center justify-center ">
        <div className="">
          {/* Friends Option */}
          <div className="flex justify-center items-center h-12">
            <div
              className={`${
                friendsOption
                  ? "h-[90%] w-[100%] flex items-center justify-center   cursor-pointer"
                  : "h-[90%] w-[100%] flex items-center justify-center   cursor-pointer "
              }`}
              data-tip="Friends"
              data-place="right"
              onClick={() => {
                setFriendsOption(true);
                friends(true);
                setSearchUsersOption(false);
                setConversationsOption(false);
                setGroupChatsOption(false);
                openSearchUser(false);
                setCodeSpaceOption(false);
                codeSpace(false);
                groups(false);
                navigate("/home/friends");
                if (setIsMobileMenuOpen) {
                  setIsMobileMenuOpen(false);
                }
              }}
            >
              <div className="relative">
                {!friendsOption ? (
                  <OutlineUserIcon
                    className="text-icon_color h-7 w-7 hover:text-icon_color2 antialiased transition-all duration-500"
                    aria-hidden="true"
                  />
                ) : (
                  <UserIcon
                    className="text-icon_color h-7 w-7 hover:text-icon_color2 antialiased transition-all duration-500"
                    aria-hidden="true"
                  />
                )}
                {friendsRequestNotification > 0 && (
                  <div className="absolute top-0 left-5 h-2 w-2  border-white rounded-full bg-[#44ff00] "></div>
                )}
              </div>
            </div>
          </div>
          {/* Conversations Option */}
          <div className="flex justify-center items-center h-12">
            <div
              className={`${
                conversationsOption
                  ? "h-[90%] w-[100%] flex items-center justify-center  cursor-pointer"
                  : "h-[90%] w-[100%] flex items-center justify-center   cursor-pointer"
              }`}
              onClick={() => {
                setSearchUsersOption(false);
                setFriendsOption(false);
                friends(false);
                groups(false);
                setGroupChatsOption(false);
                openSearchUser(false);
                setCodeSpaceOption(false);
                codeSpace(false);
                setConversationsOption(true);
                navigate("/home/inbox");
                if (setIsMobileMenuOpen) {
                  setIsMobileMenuOpen(false);
                }
              }}
              data-tip="Inbox"
              data-place="right"
            >
              {!conversationsOption ? (
                <OutlineInboxIcon
                  className="text-icon_color h-7 w-7 hover:text-icon_color2 antialiased transition-all duration-500"
                  aria-hidden="true"
                />
              ) : (
                <InboxIcon
                  className="text-icon_color h-7 w-7 hover:text-icon_color2 antialiased transition-all duration-500"
                  aria-hidden="true"
                />
              )}
            </div>
          </div>
          {/* Group Chats Option */}
          <div className="flex justify-center items-center h-12">
            <div
              className={`${
                groupChatsOption
                  ? "h-[90%] w-[100%] flex items-center justify-center  cursor-pointer"
                  : "h-[90%] w-[100%] flex items-center justify-center cursor-pointer"
              }`}
              onClick={() => {
                setSearchUsersOption(false);
                setFriendsOption(false);
                friends(false);
                setConversationsOption(false);
                openSearchUser(false);
                setCodeSpaceOption(false);
                codeSpace(false);
                setGroupChatsOption(true);
                groups(true);
                navigate("/home/groups");
                if (setIsMobileMenuOpen) {
                  setIsMobileMenuOpen(false);
                }
              }}
              data-tip="Group Conversations"
              data-place="right"
            >
              {!groupChatsOption ? (
                <OutlineUserGroupIcon
                  className="text-icon_color h-7 w-7 hover:text-icon_color2 antialiased transition-all duration-500"
                  aria-hidden="true"
                />
              ) : (
                <UserGroupIcon
                  className="text-icon_color h-7 w-7 hover:text-icon_color2 antialiased transition-all duration-500"
                  aria-hidden="true"
                />
              )}
            </div>
          </div>
          {/* CodeSpace Option */}
          <div className="flex justify-center items-center h-12">
            <div
              className={`${
                codeSpaceOption
                  ? "h-[90%] w-[100%] flex items-center justify-center cursor-pointer"
                  : "h-[90%] w-[100%] flex items-center justify-center  cursor-pointer "
              }`}
              data-tip="CodeSpace"
              data-place="right"
              onClick={() => {
                setSearchUsersOption(false);
                openSearchUser(false);
                setFriendsOption(false);
                friends(false);
                groups(false);
                setConversationsOption(false);
                setGroupChatsOption(false);
                setCodeSpaceOption(true);
                codeSpace(true);
                navigate("/home/codespace");
                if (setIsMobileMenuOpen) {
                  setIsMobileMenuOpen(false);
                }
              }}
            >
              {!codeSpaceOption ? (
                <OutlineCloudIcon
                  className="text-icon_color h-7 w-7 hover:text-icon_color2 antialiased transition-all duration-500"
                  aria-hidden="true"
                />
              ) : (
                <CloudIcon
                  className="text-icon_color h-7 w-7 hover:text-icon_color2 antialiased transition-all duration-500"
                  aria-hidden="true"
                />
              )}
            </div>
          </div>
          {/* forum icon */}
          <div className="flex justify-center items-center h-12">
            <div
              className={`${
                codeSpaceOption
                  ? "h-[90%] w-[100%] flex items-center justify-center cursor-pointer"
                  : "h-[90%] w-[100%] flex items-center justify-center  cursor-pointer "
              }`}
              data-tip="Forums"
              data-place="right"
              onClick={() => {
                navigate("/myquestions");
                if (setIsMobileMenuOpen) {
                  setIsMobileMenuOpen(false);
                }
              }}
            >
              <OutlineChatAlt2Icon className="text-icon_color h-7 w-7 hover:text-icon_color2 antialiased transition-all duration-500" />
            </div>
          </div>
        </div>
      </div>
      <div className="h-[10%]">
        {/* Settings Option */}
        <div className="flex justify-evenly p-6 items-center h-12  cursor-pointer">
          <div className="h-[90%] w-[60%] flex items-center justify-center">
            <Menu
              as="div"
              className="absolute  items-center justify-center inline-block text-left  "
            >
              <Menu.Button>
                {!issettingopen ? (
                  <OutlineCogIcon
                    className="h-6 w-6 mx-2 text-icon_color cursor-pointer hover:text-icon_color2 hover:rounded transition-all duration-300 ease-in-out"
                    aria-hidden="true"
                    data-tip="Settings"
                    data-place="right"
                    onClick={() => {
                      setissettingopen(false);
                    }}
                  />
                ) : (
                  <div
                    onClick={() => {
                      setissettingopen(true);
                     

                    }}
                  >
                    <CogIcon
                      className="h-6 w-6 mx-2 text-icon_color cursor-pointer hover:text-icon_color2 hover:rounded transition-all duration-300 ease-in-out"
                      aria-hidden="true"
                      data-tip="Settings"
                      data-place="right"
                    />
                  </div>
                )}
              </Menu.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="origin-top-center absolute  bottom-[30px] left-[20px] mt-1 w-56 rounded-md shadow-md shadow-black bg-background focus:outline-none z-10">
                  <Menu.Item>
                    {({ active }) => (
                      <a
                        href="#"
                        className={classNames(
                          active
                            ? "bg-palette_color1 text-palette_color2 rounded-t-md"
                            : "text-palette_color1",
                          "block px-4 py-2 text-sm font-robo "
                        )}
                        onClick={async (e) => {
                          e.preventDefault();
                          await changeNotification();
                          setNotifications(!notifications);
                        }}
                      >
                        {!notifications ? "Unmute" : "Mute"} Notifications
                      </a>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <a
                        href="#"
                        className={classNames(
                          active
                            ? "bg-palette_color1 text-palette_color2 "
                            : "text-palette_color1",
                          "block px-4 py-2 text-sm font-robo "
                        )}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/edit-profile");
                          if (setIsMobileMenuOpen) {
                            setIsMobileMenuOpen(false);
                          }
                        }}
                      >
                        Edit Profile
                      </a>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <a
                        href="#"
                        className={classNames(
                          active
                            ? "bg-palette_color1 text-palette_color2 rounded-b-md"
                            : "text-palette_color1",
                          "block px-4 py-2 text-sm font-robo "
                        )}
                        onClick={(e) => {
                          e.preventDefault();
                          socket.disconnect();
                          queryClient.removeQueries("recents");
                          backendService.logout();
                          navigate("/login");
                          if (setIsMobileMenuOpen) {
                            setIsMobileMenuOpen(false);
                          }
                        }}
                      >
                        Sign Out
                      </a>
                    )}
                  </Menu.Item>
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerticalMenu;
